import { Container } from "./styles";
import githubIcon from "../../assets/github.svg"
// import DownloadApp from '../../assets/download.png'
import externalLink from "../../assets/external-link.svg"
import ScrollAnimation from "react-animate-on-scroll";
import foodImage from "../../assets/food.png";
import tripifyImage from "../../assets/tripify.png";
import eccomImage1 from "../../assets/ecommerce.png";
import eccomImage2 from "../../assets/eccom.jpeg";
import realtors from "../../assets/Realtor.jpeg";
import foodImage2 from "../../assets/foodorder.jpeg";
import health from "../../assets/health.jpeg";
import car from "../../assets/CAR.jpeg";
import credit from "../../assets/credit.jpeg";

export function Project() {
  return (
    <Container id="project">
      <h2>My Projects</h2>
      <div className="projects">

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><title>Folder</title> <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path> </svg>
              <div className="project-links">
                <a href="https://food-del-frontend-2prg.onrender.com/" target="_blank" rel="noreferrer">
                  <img src={externalLink} alt="Visit site" /> </a>
                <a href="https://food-del-admin-0m8l.onrender.com/" target="_blank" rel="noreferrer">
                  <img src={externalLink} alt="Visit site" /></a>
              </div>
            </header>
            <div className="body">
              <h3>SJG FOOD RESTAURANT ORDERING WEBSITE</h3>
              <div className="project-image"><img src={foodImage} alt="Food Ordering Website" /> </div>
              <p className="project-description">
                I developed a full-featured food ordering and event management system using MongoDB, Express.js, React.js, and Node.js. The platform streamlines restaurant operations by combining menu management, order tracking, table reservations, and premium event bookings into a unified admin and user experience. Key features include a responsive admin dashboard, dynamic menu and order management, table and event reservation modules with detailed booking forms, tiered event packages with add-ons, and a rich gallery showcasing venues and services. With modular React components, clean form handling, and structured backend schemas, the system functions like a real restaurant CMS, ensuring fast updates, secure API handling, and seamless data flow. This project highlights my ability to design user-friendly interfaces, model real-world operations, and deliver end-to-end solutions that integrate both frontend polish and backend reliability.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>MERN Stack</li>
                <li>React.js</li>
                <li>CSS</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"> <title>Folder</title> <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path> </svg>
              <div className="project-links">
                <a href="#" target="_blank" rel="noreferrer">
                  <img src={githubIcon} alt="Visit site" /></a>
                <a href="https://tripify-gamma.vercel.app/" target="_blank" rel="noreferrer">
                  <img src={externalLink} alt="Visit site" />
                </a> </div>
            </header>
            <div className="body">
              <h3>TRIPIFY TRAVEL BOOKING PLATFORM</h3>
              <div className="project-image"><img src={tripifyImage} alt="Tripify Travel Booking Platform"/> </div>
              <p>I built a polished fullstack travel booking website that helps users discover, compare, and book destinations, hotels, and vehicles. The platform features dynamic destination listings, detailed hotel and vehicle pages, wishlist and booking flows, a blog and newsletter. With modular, type-safe components and responsive layouts, Tripify delivers a production-ready travel experience while showcasing my ability to integrate modern frontend design with scalable backend services. </p>
            </div>
            <footer> <ul className="tech-list"> <li>Next.js</li> <li>Typescript</li> <li>Tailwind CSS</li> <li>Swiper.js</li> </ul> </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                <title>Folder</title>
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
              </svg>
              <div className="project-links">
                <a href="#" target="\_blank" rel="noreferrer">
                  <img src={githubIcon} alt="Visit site" />
                </a>
                <a href="#" target="\_blank" rel="noreferrer">
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>E-COMMERCE PLATFORM</h3>
              <div className="project-image"><img src={eccomImage1} alt="Netflix Ent Clone"/> </div>
              <p>
                I developed a full-featured eCommerce solution that delivers a seamless shopping experience for users while empowering admins with advanced product, order, and customer management tools. The platform covers the complete commerce lifecycle, from product discovery, cart, and checkout (with Stripe/PayPal integration) to shipping details and order confirmation. On the admin side, I built a robust dashboard with role-agnostic management of products, users, and orders, alongside real-time analytics and data visualization for revenue, traffic, and product popularity. Leveraging Next.js App Router, Tailwind CSS, TypeScript, and Zod validation, I focused on modular UI components, secure API routes, and responsive design, ensuring scalability, performance, and a clean user experience across devices.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Next.js</li>
                <li>Tailwind CSS</li>
                <li>Typescript</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
              <div className="project-links">
                <a href="#" target="_blank" rel="noreferrer">
                  <img src={githubIcon} alt="Visit site" />
                </a>
                <a href="https://bensavage-expo-ecommerece-app.expo.app/" target="_blank" rel="noreferrer">
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>ECOMMERCE MOBILE APP</h3>
              <div className="project-image"><img src={eccomImage2} alt="Health"/> </div>
              <p>I built a polished mobile e-commerce app with React Native (Expo) and TypeScript that showcases a full shopping flow using a lightweight JSON file as the data source (easy to swap for an API later). The app features a clean Home with banners and personalized picks, category chips and an Explore screen, flash-sale timers, product cards with price and ratings, wishlists (heart icon), a badged Cart, and a bottom tab navigation for Home/Explore/Notifications/Cart/Profile. I focused on reusable components, type-safe models, and clear state management to keep the UI snappy and maintainable, while the JSON “database” is organized like a real catalog (categories, products, prices, images) to enable fast prototyping and reliable demos.</p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>React Native</li>
                <li>TypeScript</li>
                <li>Expo</li>
                <li>JSON</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                <title>Code</title>
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
              </svg>
              <div className="project-links">
                <a href="#" target="_blank" rel="noreferrer">
                  <img src={githubIcon} alt="Visit site" />
                </a>
                <a href="https://bensavage-real-estate.expo.app/" target="_blank" rel="noreferrer">
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>REALTORS MOBILE APP</h3>
              <div className="project-image"><img src={realtors} alt="CAR" /> </div>
              <p>I built a polished fullstack Mobile Real Estate App (React Native, Expo, TypeScript, Appwrite) – I built a polished mobile-first real estate application designed for realtors to seamlessly list and manage properties. The app delivers a complete property discovery and booking flow, including a clean home screen with personalized recommendations, category filters, detailed property views with facility icons, embedded map previews, and live booking actions. Realtors benefit from a modular agent dashboard powered by Sanity.io for real-time listing updates and media uploads, while Appwrite ensures secure authentication, database operations, and user sessions with Google login. Architected with reusable components, type-safe models, and responsive layouts, the app mirrors a real-world property catalog with agents, categories, listings, and bookings — making it production-ready, scalable, and an excellent demonstration of both frontend finesse and backend integration.</p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>React Native</li>
                <li>TypeScript</li>
                <li>Expo</li>
                <li>Appwrite</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
              <div className="project-links">
                <a href="#" target="_blank" rel="noreferrer">
                  <img src={githubIcon} alt="Visit site" /></a>
                <a href="#" target="_blank" rel="noreferrer">
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>FOOD ORDERING MOBILE APP</h3>
              <div className="project-image"><img src={foodImage2} alt="CREDIT"/></div>
              <p>
                I built a sleek mobile food ordering app with React Native (Expo) and JavaScript, powered by Sanity.io as both the database and admin CMS. The app delivers a full ordering experience — from browsing to checkout — with dynamic content pulled from structured Sanity datasets. It features a vibrant Home screen with category chips (Fast Food, Drinks, Sweets, etc.), location-based filtering, and rich food cards with ratings, distance, and thumbnails. Users can explore curated sections like “Hot and Spicy” or “Chinese Spice,” tap into detailed restaurant menus with add-to-cart functionality, and track their delivery live on a map with ETA and rider info.
                I focused on modular components, responsive layouts, and seamless state transitions to ensure a smooth UX. The Sanity backend is modeled like a real restaurant catalog — with categories, vendors, menu items, and orders — making it easy to scale or demo with live updates via the admin site.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>React Native</li>
                <li>JavaScript</li>
                <li>Sanity.io</li>
                <li>Expo</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
              <div className="project-links">
                <a href="#" target="_blank" rel="noreferrer">
                  <img src={githubIcon} alt="Visit site" />
                </a>
                <a href="#" target="_blank" rel="noreferrer">
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>HEART DISEASE & BREAST CANCER PREDICTION</h3>
              <div className="project-image"><img src={health} alt="Health"/> </div>
              <p>Diagnosing Malignant versus Benign Breast Tumours via Machine Learning Techniques in High Dimensions. Logistc Regression, SVM and Decision Tree methods to classify data.Machine Learning project to predict heart diseases. Predicting chance of heart disease in people using Regression and Decision Tree algorithms</p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Numpy</li>
                <li>Panda</li>
                <li>Matplotlib</li>
                <li>SKlearn</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                <title>Code</title>
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
              </svg>
              <div className="project-links">
                <a href="#" target="_blank" rel="noreferrer">
                  <img src={githubIcon} alt="Visit site" />
                </a>
                <a href="#" target="_blank" rel="noreferrer">
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>CAR PRICE PREDICTION</h3>
              <div className="project-image"><img src={car} alt="CAR"/> </div>
              <p>I'll use various machine learning algorithms to predict the price of used cars. Machine learning model with linear regression for car price prediction</p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Numpy</li>
                <li>Pandas</li>
                <li>Matplotlib</li>
                <li>Seaborn</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
              <div className="project-links">
                <a href="#" target="_blank" rel="noreferrer">
                  <img src={githubIcon} alt="Visit site" /></a>
                <a href="#" target="_blank" rel="noreferrer">
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>CREDIT RISK ANALYSIS</h3>
              <div className="project-image"><img src={credit} alt="CREDIT"/> </div>
              <p>
                Developed a highly accurate credit risk classification model using XGBoost, achieving 100% precision, recall, and F1-scores for predicting loan defaults.Implemented rigorous data preprocessing, feature engineering, and hyperparameter tuning on imbalanced credit risk data, employing ensemble methods, cross-validation, and model interpretation techniques.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>XGBoost</li>
                <li>Pandas</li>
                <li>Numpy</li>
                <li>Matplotlib</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>
      </div>
    </Container>
  );
}